import { loadPlanAssignmentPane } from './plan-assignment-pane';
import { showErrorNotification } from '../../global/notifications';
import { listenForPlanUpdate } from './event-handlers';

let _$planAssignmentTopic = $('#PlanAssignment');

let _selectedEmployee = null;
let _selectedPlanAssignment = null;

export function loadPlanAssignmentList(selectedEmployee) {
    listenForPlanUpdate(() => loadPlanAssignmentList(_selectedEmployee));

    _selectedEmployee = selectedEmployee;
    const data = {
        employeeNumber: selectedEmployee.EmployeeNumber
    };

    return new Promise((resolve, reject) => {
        $('#PlanAssignmentList').load('/Commissions/CommissionPlanAssignment/GetPlanAssignmentListPane', data, (response, status) => {
            if (status === 'error') {
                reject(new Error('Failed to load plan information'));
                return;
            }

            initializeGridControls();
            resolve();
        });
    });
}

function initializeGridControls() {
    $('#plan-add-button').on('click', function () { showPlanAssignment(null); });
    $('.plan-edit-button').on('click', function () { showPlanAssignment($(this).data('id')); });
}


function showPlanAssignment(e) {
    _$planAssignmentTopic.hide();
    _selectedPlanAssignment = e;

    loadPlanAssignmentPane(_selectedEmployee, _selectedPlanAssignment)
        .then(showPlanAssignmentPaneSection)
        .catch(error => showErrorNotification(error));
}

function showPlanAssignmentPaneSection() {
    _$planAssignmentTopic.show();
}
